import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export async function fetchServices() {
  const { data } = await api.get("/services");
  return data;
}

export async function createBooking(payload) {
  const { data } = await api.post("/bookings", payload);
  return data;
}

export async function fetchBooking(reference) {
  const { data } = await api.get(`/bookings/${reference}`);
  return data;
}
